import { render, staticRenderFns } from "./multiInput.vue?vue&type=template&id=653d96e2"
import script from "./multiInput.vue?vue&type=script&lang=js"
export * from "./multiInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports